"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArrowDownSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ArrowDownSVG = function ArrowDownSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M24.39,16.38a2,2,0,0,0-2.94,0L18,20V7a2,2,0,0,0-4,0V20l-3.45-3.62a2,2,0,0,0-2.94,0,2.16,2.16,0,0,0,0,3l6.86,7a2.2,2.2,0,0,0,3.06,0l6.86-7A2.16,2.16,0,0,0,24.39,16.38Z"
  }));
};
exports.ArrowDownSVG = ArrowDownSVG;
ArrowDownSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ArrowDownSVG);
exports.default = _default;